// @ts-nocheck
import { useEffect, useState } from 'react'
import { getDrupalSetting, getWindow } from '@ggs/utils'
import { useScript, useSimpleMapScripts } from '@ggs/hooks/index'

const useAllEmbedSimpleMapScripts = () => {
  const baseUrl =
    getDrupalSetting('baseUrl') || `${process.env.REACT_APP_DRUPAL_BASE_URL}` || 'http://localhost'
  const [allStatuses, setAllStatuses] = useState('loading')
  const [canadaStatus, setCanadaStatus] = useState('loading')
  const [usStatus, setUsStatus] = useState('loading')
  const [europeStatus, setEuropeStatus] = useState('loading')
  const [caribbeanStatus, setCaribbeanStatus] = useState('loading')
  const [asiaStatus, setAsiaStatus] = useState('loading')
  const canadaMapScriptsStatus = useSimpleMapScripts([
    `${baseUrl}/modules/custom/t4_react/js/maps/canada/mapdata.js`,
    `${baseUrl}/modules/custom/t4_react/js/maps/canada/canadamap.js`,
    `${baseUrl}/modules/custom/t4_react/js/maps/canada/select.js`
  ])
  const usMapScriptsStatus = useSimpleMapScripts([
    `${baseUrl}/modules/custom/t4_react/js/maps/us/mapdata.js`,
    `${baseUrl}/modules/custom/t4_react/js/maps/us/usmap.js`,
    `${baseUrl}/modules/custom/t4_react/js/maps/us/select.js`
  ])
  const europeMapDataScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/europe/mapdata.js`)
  const europeMapScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/europe/europemap.js`)
  const caribbeanMapDataScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/caribbean/mapdata.js`)
  const caribbeanMapScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/caribbean/caribbeanmap.js`)
  const asiaMapDataScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/asia/mapdata.js`)
  const asiaMapScriptStatus = useScript(`${baseUrl}/modules/custom/t4_react/js/maps/asia/asiamap.js`)
  // All scripts should in separate useEffect hook.
  /* eslint-disable */
  useEffect(() => {
    if (canadaMapScriptsStatus === 'ready') {
      simplemaps_canadamap_mapdata.main_settings.auto_load = 'no'
      simplemaps_canadamap_mapdata.main_settings.all_states_zoomable = 'no'
      simplemaps_canadamap_mapdata.main_settings.state_url = ''
      setCanadaStatus('ready')
    }
  }, [canadaMapScriptsStatus])

  useEffect(() => {
    if (usMapScriptsStatus === 'ready') {
      simplemaps_usmap_mapdata.main_settings.auto_load = 'no'
      simplemaps_usmap_mapdata.main_settings.all_states_zoomable = 'no'
      simplemaps_usmap_mapdata.main_settings.state_url = ''
      setUsStatus('ready')
    }
  }, [usMapScriptsStatus])

  useEffect(() => {
    if (europeMapDataScriptStatus === 'ready' && europeMapScriptStatus === 'ready') {
      simplemaps_europemap_mapdata.main_settings.auto_load = 'no'
      simplemaps_europemap_mapdata.main_settings.all_states_zoomable = 'no'
      simplemaps_europemap_mapdata.main_settings.state_url = ''
      setEuropeStatus('ready')
    }
  }, [europeMapDataScriptStatus, europeMapScriptStatus])

  useEffect(() => {
    if (caribbeanMapDataScriptStatus === 'ready' && caribbeanMapScriptStatus === 'ready') {
      simplemaps_caribbeanmap_mapdata.main_settings.auto_load = 'no'
      simplemaps_caribbeanmap_mapdata.main_settings.all_states_zoomable = 'no'
      simplemaps_caribbeanmap_mapdata.main_settings.state_url = ''
      setCaribbeanStatus('ready')
    }
  }, [caribbeanMapDataScriptStatus, caribbeanMapScriptStatus])

  useEffect(() => {
    if (asiaMapDataScriptStatus === 'ready' && asiaMapScriptStatus === 'ready') {
      simplemaps_asiamap_mapdata.main_settings.auto_load = 'no'
      simplemaps_asiamap_mapdata.main_settings.all_states_zoomable = 'no'
      simplemaps_asiamap_mapdata.main_settings.state_url = ''
      setAsiaStatus('ready')
    }
  }, [asiaMapDataScriptStatus, asiaMapScriptStatus])
  /* eslint-enable */

  useEffect(() => {
    if (canadaStatus === 'ready'
      && usStatus === 'ready'
      && europeStatus === 'ready'
      && caribbeanStatus === 'ready'
      && asiaStatus === 'ready') {
      setAllStatuses('ready')
    }
  }, [
    canadaStatus,
    usStatus,
    europeStatus,
    caribbeanStatus,
    asiaStatus
  ])

  return allStatuses
}

export default useAllEmbedSimpleMapScripts
